import React from "react";

import { useStyles } from "./styles";

export const ProLabel = ({ margin }: ProLabelProps) => {
  const classes = useStyles({ margin });

  return (
    <span className={classes.chip}>
      {'PRO'}  
    </span>
  );
};

type Margin = {
  [key in 'top' | 'right' | 'bottom' | 'left']?: number;
}

export interface ProLabelProps {
  margin?: Margin | number;
}
